<template>
    <Head>
        <title>Programas</title>
    </Head>
    <div class="hero-img-overlay hero-lila" style="background-image: url(/img/hero-dif.png);">
        <div class="container">
            <div class="row">
                <div class="col-md-6 col-lg-7">
                    <h1 class="hero-encabezado">Programas</h1>
                </div>
            </div>
        </div>
    </div>
    <div class="contenido-wrapper">
        <div class="bloque-general">
            <div class="container">
                <div class="row">
                    <div class="col-12">
                        <h2 class="tramites-servicios__listado-encabezado">Listado de Programas</h2>
                        <div class="tramites-servicios__filtros">
                            <form action="#">
                                <div class="form-group">
                                    <input class="input-buscador" v-model="search" type="text" placeholder="Nombre o información del programa ...">
                                </div>
                                <div class="form-group">
                                    <select class="form-control form__select" v-model="secretaria">
                                        <option value="" :selected="secretaria == ''">Todas las Secretarías
                                        </option>
                                        <option v-for="(item, i) in secretarias" :key="i" :value="item.id">{{ item.nombre }}</option>
                                    </select>
                                </div>
                                <div class="form-group">
                                    <button type="button" @click="searching()" class="bot-buscar boton-principal ml-sm-4">Buscar</button>
                                </div>
                            </form>
                        </div>
                        <div class="tramites-servicios__listado">
                            <div v-if="programas.data.length < 1">
                                <NoResults />
                            </div>
                            <Link v-for="(item, i) in programas.data" :key="i" :href="`/programa/` + item.slug" class="tramite-servicio-item">
                            <img loading="lazy" width="69" height="60" class="tramite-servicio-item__icono" :src="'/img/icono-hexagono-' + item.secretaria.icono + '.svg'" alt="" />
                            <div class="tramite-servicio-item__info">
                                <div class="tramite-servicio-item__nombre">{{ item.nombre }}</div>
                                <div class="tramite-servicio-item__secretaria mb-2">{{ item.secretaria.nombre }}</div>
                                <span class="badge etiqueta-simple" style="font-size: 11px;">PROGRAMA {{ item.tipo }}</span>
                            </div>
                            <div class="tramite-servicio-item__info">
                                <div class="tramite-servicio-item__informacion mt-3 mt-md-0 ml-sm-2">{{ item.informacion_corta }}</div>
                            </div>
                            <div class="tramite-servicio-item__modalidades">
                                <button class="boton-principal boton-flecha">Ver programa</button>
                            </div>
                            </Link>
                        </div>
                        <div class="row" v-if="programas.total > limit">
                            <div class="col-12">
                                <Paginacion :links="programas.links" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import NoResults from "../../Shared/Utils/NoResults.vue";
import { Link } from '@inertiajs/inertia-vue3'
import Paginacion from '../../Shared/Paginacion.vue';
import { Inertia } from '@inertiajs/inertia';

export default {
    props: {
        programas: Object,
        secretarias: Object,
        frecuentes: Object,
        limit: Number,
        filters: Object,
    },
    data() {
        return {
            search: this.filters.search,
            secretaria: (this.filters.secretaria == null) ? '' : this.filters.secretaria,
        }
    },
    components: {
        NoResults,
        Link,
        Paginacion,
    },
    methods: {
        searching() {
            Inertia.get('/programas', {
                search: this.search,
                secretaria: this.secretaria,
            }, {
                preserveState: true,
                preserveScroll: true,
                replace: true
            })
        },
        next() {
            this.$refs.itemsFrecuentes.next()
        },
        prev() {
            this.$refs.itemsFrecuentes.prev()
        }
    }
}
</script>
<style scoped>
.slider-tramites-servicios .tramite-servicio-item {
    text-align: left;
}

.bot-buscar {
    width: 150px;
    height: 50px;
    padding-top: 10px;
}

.carousel__pagination .carousel__pagination-button {
    width: 10px !important;
    height: 12px !important;
    border-radius: 50% !important;
}

.slider-tramites-servicios .tramite-servicio-item {
    margin-right: 0;
    padding-right: 20px;
}

.tramite-servicio-item__secretaria a {
    color: inherit;
}
.tramite-servicio-item__info {
    width: 350px;
}
.tramite-servicio-item__informacion{
    font-size: 15px;
    color: #333;
    line-height: 1.3em;
    width: 370px;
}
.tramite-servicio-item__modalidades{
    text-align: center;
    width: 200px;
    max-width: max-content;
}
.boton-flecha {
    height: 50px;
    font-size: 15px;
    padding: 0;
    width: 155px;
    line-height: 1em;
}
</style>
